module.exports = __webpack_public_path__ + "static/media/bg_feature_5.ea0b4957.jpg";